export enum LayoutURLParamsEnum {
  moduleName = 'moduleName',
  tabName = 'tabName',
  subTabName = 'subTabName',
}
